import React, { ReactElement } from 'react';
import { ZaznamSekcie } from 'tezaury-frontend-ts-axios';
import { Link } from 'idsk-react-components';
import DetailTerminuRow from '../DetailTerminuRow/DetailTerminuRow';
import DetailTerminuList from '../DetailTerminuList/DetailTerminuList';

interface Props {
  list: Array<ZaznamSekcie>;
  header: string;
}

const DetailTerminuJudikatyARozdeleniaSudovSection = ({ list, header }: Props): ReactElement => {
  const renderItemZaznamSekcie = (item: ZaznamSekcie): ReactElement => {
    if (item.url) {
      return (
        <Link
          className="detail-terminu-button-link"
          to={item.url}
          target="_top"
        >
          {item.nazov}
        </Link>
      );
    }
    return (
      <>
        {item.nazov}
      </>
    );
  };

  return (
    <>
      {list.length > 0 && (
        <div className="dokument-detail">
          <DetailTerminuRow header={header}>
            <DetailTerminuList
              list={list}
              renderItem={renderItemZaznamSekcie}
              renderKey={(item) => item.uuid}
            />
          </DetailTerminuRow>
        </div>
      )}
    </>
  );
};

export default DetailTerminuJudikatyARozdeleniaSudovSection;
